<template>
  <div class="event-detail">
    <div class="event-trend">
      <div class="row name">{{eventName}}</div>
      <event-trend :event-id="eventId"></event-trend>
    </div>
    <div class="row event-list">
      <div class="event-time-list">
        <sn-header :title="'事件时间轴'">
          <el-select class="event-select" @change="onChange"  v-model="option" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </sn-header>
        <div class="event-time-list-detail" v-loading="isLoading">
          <event-time-list-item v-for="(item, index) in eventDetailList" :key="index" :data="item"></event-time-list-item>
        </div>
      </div>
      <div class="event-list-right">
        <div class="perimeter-companies">
          <div class="row perimeter-companies-header" v-if="eventRelatedCompanyAllOriginalData.length">
            <el-select class="perimeter-companies-select" :class="{'perimeter-companies-select-one': perimeterCompanyOptions.length === 1}" @change="onPerimeterCompanyChange"  v-model="perimeterCompanyOption">
              <el-option
                v-for="item in perimeterCompanyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="row perimeter-companies-to-graph">
              <img class="img" src="../assets/img/arrow-right-up.svg" >
              <div class="perimeter-companies-to-graph-word" @click="toGraphCompanyPage">完整图谱</div>
            </div>
          </div>
          <div class="row perimeter-companies-tab" v-if="eventRelatedCompanyAllOriginalData.length">
            <div
              class="tab-item" 
              :class="{'tab-item-active': item === perimeterCompanySelectedOptionTab}" 
              v-for="(item, index) in perimeterCompanyTabs" 
              :key="index"
              @click="onPerimeterCompanyTabChange(item)"
              >
              {{item}}
            </div>
          </div>
          <div class="event-related-company" v-if="eventRelatedCompanyAllOriginalData.length">
            <div v-if="perimeterCompanySelectedOptionTab === '全部'">
              <div class="event-related-company-relation" v-for="(item, index) in eventRelatedCompanyAllData" :key="index">
                <div class="event-related-company-relation-name">{{item.relation}}</div>
                <div v-for="(i, idx) in item.related_companies" :key="idx">
                  <div class="event-related-company-relation-company" @click="toCompanyDetail(i.name)">{{i.stock_code}}</div>
                </div>
              </div>
            </div>
            <div v-if="perimeterCompanySelectedOptionTab !== '全部'">
              <div v-for="(item, index) in eventRelatedCompanyData" :key="index">
                <div class="event-related-company-relation-company" @click="toCompanyDetail(item.name)">{{item.stock_code}}</div>
              </div>
            </div>
          </div>
          <img v-if="!eventRelatedCompanyAllOriginalData.length" class="perimeter-company-no-data-img" src="../assets/img/perimeter-company-no-data.svg" alt /> 
          <div v-if="!eventRelatedCompanyAllOriginalData.length" class="perimeter-company-no-data">暂时没有周边公司数据,正在持续补充中...</div>
        </div>
        <div class="related-event">
          <sn-header :title="'相关事件'"></sn-header>
          <div class="related-event-detail">
            <RelatedEventNewsItem class="recommend-event-news-item-container" v-for="(item, index) in eventList" :key="index" :data="item"></RelatedEventNewsItem>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import EventTrend from '@/components/news-monitor/EventTrend';
import EventTimeListItem from '@/components/news-monitor/EventTimeListItem';
import SnHeader from '@/components/common/SnHeader';
import RelatedEventNewsItem from '@/components/recommend/RelatedEventNewsItem';

export default {
  data() {
    return {
      isLoading: false,
      perimeterCompanySelectedOptionTab: '全部',
      perimeterCompanyTabs: ['全部'],
      perimeterCompanyOption: '',
      perimeterCompanyNameOption: '',
      perimeterCompanyOptions: [],
      eventRelatedCompanyAllOriginalData: [],
      eventRelatedCompanyAllData: [],
      eventRelatedCompanyData: [],
      eventList: [],
      eventId: 0,
      eventName: '',
      option: 'desc',
      options: [
        {
          value: 'desc',
          label: '正序'
        },
        {
          value: 'asc',
          label: '倒序'
        }
      ],
      eventDetailList: [],
      data: []
    };
  },
  methods: {
    toGraphCompanyPage() {
      this.eventRelatedCompanyAllOriginalData.forEach(item => {
        if (item.stock_code === this.perimeterCompanyOption) {
          this.perimeterCompanyNameOption = item.name;
        }
      });
      const routeUrl = this.$router.resolve({
        path: '/graph', 
        query: {
          id: this.perimeterCompanyNameOption,
          label: this.perimeterCompanyOption
        }  
      });
      window.open(routeUrl.href, '_blank');
    },
    onPerimeterCompanyTabChange(res) {
      this.perimeterCompanySelectedOptionTab = res;
      if (this.perimeterCompanySelectedOptionTab !== '全部') {
        this.eventRelatedCompanyData = this.eventRelatedCompanyAllData.filter(item => item.relation === this.perimeterCompanySelectedOptionTab);
        this.eventRelatedCompanyData = this.eventRelatedCompanyData[0].related_companies;
      }
    },
    onPerimeterCompanyChange(res) {
      this.perimeterCompanyOption = res;
      this.perimeterCompanySelectedOptionTab = '全部';
      this.eventRelatedCompanyAllOriginalData.forEach(item => {
        if (item.stock_code === this.perimeterCompanyOption) {
          this.eventRelatedCompanyAllData = item.relation_and_related_companies;
          let relationTitle = [];
          relationTitle = item.relation_and_related_companies.map(i => i.relation);
          this.perimeterCompanyTabs = ['全部'];
          this.perimeterCompanyTabs = this.perimeterCompanyTabs.concat(relationTitle);
        }
      });
    },
    toCompanyDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/result', 
        query: {
          q: res
        }  
      });
      window.open(routeUrl.href, '_blank');
    },
    onChange(res) {
      this.option = res;
      this.getEventNewsList();
    },
    getEventNewsList() {
      this.isLoading = true;
      QuestionQuery.getEventNewsList(this.option, this.eventId).then(res => {
        this.isLoading = false;
        this.eventDetailList = res;
      });
    },
    getEventRelated() {
      QuestionQuery.getEventRelated(this.eventId).then(res => {
        this.eventList = res.map(item => {
          return {
            heat: item.heat,
            title: item.title,
            count: item.count,
            firstTime: item.min_publish_date,
            lastTime: item.max_publish_date,
            eventId: item.event_id,
            sentiment: item.sentiment,
            companies: item.companies
          };
        });
      });
    },
    getEventRelatedCompany() {
      QuestionQuery.getEventRelatedCompany(this.eventId).then(res => {
        this.eventRelatedCompanyAllOriginalData = res;
        if (this.eventRelatedCompanyAllOriginalData.length) {
          this.perimeterCompanyOption = this.eventRelatedCompanyAllOriginalData[0].stock_code;
          this.perimeterCompanyOptions = this.eventRelatedCompanyAllOriginalData.map(item => {
            return {
              value: item.stock_code,
              label: item.stock_code
            };
          });
          let relationTitle = [];
          relationTitle = this.eventRelatedCompanyAllOriginalData[0].relation_and_related_companies.map(item => item.relation);
          this.perimeterCompanyTabs = this.perimeterCompanyTabs.concat(relationTitle);
          this.eventRelatedCompanyAllData = this.eventRelatedCompanyAllOriginalData[0].relation_and_related_companies;
        }
      });
    }
  },
  components: {
    EventTrend,
    SnHeader,
    EventTimeListItem,
    RelatedEventNewsItem
  },
  async created() {
    this.eventName = this.$route.query.title;
    this.eventId = Number(this.$route.query.id);
  },
  mounted() {
    this.getEventNewsList();
    this.getEventRelated();
    this.getEventRelatedCompany();
  }
};
</script>

<style lang="scss" scoped>
.event-detail {
  width: 1200px;
  margin: 0 auto;
  padding: 16px 0 24px;
  .event-trend {
    background-color: #ffffff;
    .name {
      padding: 16px 24px;
      width: 100%;
      color: #171f46;
      font-size: 24px;
    }
  }
  .event-list {
    margin-top: 10px;
    .event-time-list {
      margin-right: 10px;
      width: 790px;
      .event-select {
        width: 72px;
      }
      .event-time-list-detail {
        padding-left: 31px;
        width: 100%;
        height: 680px;
        overflow: auto;
        background-color: #ffffff;
      }
    }
    .event-list-right {
      width: 400px;
      .perimeter-companies {
        position: relative;
        margin-bottom: 10px;
        width: 100%;
        height: 314px;
        background-color: #ffffff;
        .perimeter-company-no-data-img {
          position: absolute;
          left: 50%;
          top: 39px;
          transform: translateX(-50%);
        }
        .perimeter-company-no-data {
          position: absolute;
          top: 184px;
          left: 50%;
          transform: translateX(-50%);
          color: #9ea1b4;
          font-size: 14px;
          .company-name {
            color: #45a8cc;
          } 
        }
        .perimeter-companies-header {
          justify-content: space-between;
          padding: 0 24px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #f7f7fa;
          .perimeter-companies-select {
            width: 260px;
          }
          .perimeter-companies-to-graph {
            cursor: pointer;
            .img{
               width: 14px;
            }
            .perimeter-companies-to-graph-word {
              margin-left: 4px;
              color: #45a8cc;
              font-size: 14px;
            }
          }
        }
        .perimeter-companies-tab {
          overflow: auto;
          height: 28px;
          line-height: 28px;
          padding: 0 24px;
          border: 1px solid #f7f7fa;
          color: #9ea1b4;
          font-size: 12px;
          .tab-item {
            margin-right: 10px;
            flex-shrink: 0;
            cursor: pointer;
          }
          .tab-item-active {
            color: #45a8cc;
          }
        }
        .event-related-company {
          padding: 10px 16px;
          height: 226px;
          overflow: auto;
          .event-related-company-name {
            width: 100%;
            padding: 5px 8px;
            color: #45a8cc;
            font-size: 14px;
            box-shadow: inset 0px -1px 0px 0px#f7f7fa;
            cursor: pointer;
          }
          .event-related-company-relation {
            margin-bottom: 10px;
            .event-related-company-relation-name {
              height: 28px;
              width: 100%;
              padding: 4px 8px;
              color: #45a8cc;
              font-size: 12px;
            }
            .event-related-company-relation-company {
              width: 100%;
              padding: 5px 8px;
              color: #464d6c;
              font-size: 14px;
              cursor: pointer;
              &:hover {
                background-color: #f7f8fc;
              }
            }
          }
          .event-related-company-relation-company {
            width: 100%;
            padding: 5px 8px;
            color: #464d6c;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              background-color: #f7f8fc;
            }
          }
        }
      }
      .related-event {
        height: 400px;
        width: 400px;
        background-color: #ffffff;
        .related-event-detail {
          padding: 12px 0;
          height: 356px;
          width: 100%;
          overflow: auto;
          .recommend-event-news-item-container {
            padding: 12px 24px;
          }
        }
      }
    }
  }
}
  /deep/ {
    .el-select.perimeter-companies-select .el-input__inner {
      padding-left: 0;
      height: 26px;
      border: none; 
      color: #171f46;
      background-color: #ffffff !important;
      font-size: 14px;
    }
    .el-select.perimeter-companies-select .el-input .el-select__caret {
      color: #171f46;
    }
    .el-select.perimeter-companies-select-one .el-input .el-select__caret {
      display: none;
    }
    .el-select .el-input__inner {
      height: 26px;
      border: none !important; 
      color: #464d6c;
      background-color: #f7f8fc !important;
      font-size: 14px;
      &:hover {
        background-color: #eaebef !important;
      }
    }
  }
</style>
